import _memoize from 'lodash/memoize';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { middle, SCREEN_WIDTH } from '../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const RECTANGLE_HEIGHT = {
  [HD]: 88,
  [FULL_HD]: 88,
};

export const PICTO_HEIGHT = {
  [HD]: 60,
  [FULL_HD]: 60,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const getInitialStyle = _memoize(({ screenSize, colorMode } = defaultContext) => ({
  Rectangle: {
    rect: true,
    zIndex: 2,
    w: SCREEN_WIDTH[screenSize],
    h: RECTANGLE_HEIGHT[screenSize],
    color: colors.background[colorMode],
    Label: {
      mount: 0.5,
      x: middle,
      y: middle,
      text: {
        ...getFont(FONT.OTTAWA_1, screenSize),
      },
    },
  },
}));
